/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProducts = /* GraphQL */ `
  query GetProducts($code: String) {
    getProducts(code: $code) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
    }
  }
`;
export const getServices = /* GraphQL */ `
  query GetServices($code: String) {
    getServices(code: $code) {
      code
      description
    }
  }
`;
export const getProductTypes = /* GraphQL */ `
  query GetProductTypes {
    getProductTypes {
      id
      name
    }
  }
`;
export const getParts = /* GraphQL */ `
  query GetParts {
    getParts {
      number
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      service_code
      part_number
      product_id
    }
  }
`;
export const itemReader = /* GraphQL */ `
  query ItemReader($input: ItemInput!) {
    itemReader(input: $input) {
      serial
      product_id
      person_id
      date_purchase
      date_production
      image_key
      order_number
      po_number
      description
      first_name
      last_name
      email
    }
  }
`;
export const personReader = /* GraphQL */ `
  query PersonReader($input: PersonInput!) {
    personReader(input: $input) {
      id
      cognito_id
      first_name
      last_name
      address
      country
      email
    }
  }
`;
export const companyReader = /* GraphQL */ `
  query CompanyReader($input: CompanyInput) {
    companyReader(input: $input) {
      id
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
    }
  }
`;
export const roleReader = /* GraphQL */ `
  query RoleReader($input: RoleInput) {
    roleReader(input: $input) {
      id
      name
    }
  }
`;
export const personCompanyRoleReader = /* GraphQL */ `
  query PersonCompanyRoleReader($input: PersonCompanyRoleInput) {
    personCompanyRoleReader(input: $input) {
      user_id
      company_id
      role_id
      role_name
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
    }
  }
`;
export const usersFromPersonCompanyRoleReader = /* GraphQL */ `
  query UsersFromPersonCompanyRoleReader($input: PersonCompanyRoleInput) {
    usersFromPersonCompanyRoleReader(input: $input) {
      id
      cognito_id
      first_name
      last_name
      address
      country
      email
    }
  }
`;
export const rolesFromPersonCompanyRoleReader = /* GraphQL */ `
  query RolesFromPersonCompanyRoleReader($input: PersonCompanyRoleInput) {
    rolesFromPersonCompanyRoleReader(input: $input) {
      id
      name
    }
  }
`;
export const warrantyReader = /* GraphQL */ `
  query WarrantyReader($input: WarrantyInput) {
    warrantyReader(input: $input) {
      id
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      total
      submitted
      instance_landing
      instance_labor
    }
  }
`;
export const serviceProductPartReader = /* GraphQL */ `
  query ServiceProductPartReader($input: ServiceProductPartInput) {
    serviceProductPartReader(input: $input) {
      service_code
      part_number
      product_id
    }
  }
`;
export const partsFromServiceCode = /* GraphQL */ `
  query PartsFromServiceCode($input: ServiceProductPartInput) {
    partsFromServiceCode(input: $input) {
      number
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      service_code
      part_number
      product_id
    }
  }
`;
export const servicePartsFromWarranty = /* GraphQL */ `
  query ServicePartsFromWarranty($input: WarrantyInput) {
    servicePartsFromWarranty(input: $input) {
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      warranty_id
      service_code
      part_number
      price
      qty
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
      total
      submitted
      date_purchase
      date_production
      description
    }
  }
`;
export const jobsFromCompanyReader = /* GraphQL */ `
  query JobsFromCompanyReader($input: CompanyJobInput) {
    jobsFromCompanyReader(input: $input) {
      id
      name
    }
  }
`;
export const rolesFromJobsReader = /* GraphQL */ `
  query RolesFromJobsReader($input: JobRoleInput) {
    rolesFromJobsReader(input: $input) {
      id
      name
    }
  }
`;
export const getWarrantyPlus = /* GraphQL */ `
  query GetWarrantyPlus($input: WarrantyInput) {
    getWarrantyPlus(input: $input) {
      warranty_id
      id
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      total
      submitted
      instance_landing
      instance_labor
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
      date_purchase
      date_production
      description
      product_id
      order_number
      po_number
    }
  }
`;
export const getWarrantyFull = /* GraphQL */ `
  query GetWarrantyFull($input: WarrantyInput) {
    getWarrantyFull(input: $input) {
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      warranty_id
      service_code
      part_number
      price
      qty
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
      total
      submitted
      date_purchase
      date_production
      description
    }
  }
`;
export const getWarrantyFilteredFull = /* GraphQL */ `
  query GetWarrantyFilteredFull($input: WarrantyFilteredInput) {
    getWarrantyFilteredFull(input: $input) {
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      warranty_id
      service_code
      part_number
      price
      qty
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
      total
      submitted
      date_purchase
      date_production
      description
    }
  }
`;
export const getWarrantyFilteredPlus = /* GraphQL */ `
  query GetWarrantyFilteredPlus($input: WarrantyFilteredInput) {
    getWarrantyFilteredPlus(input: $input) {
      warranty_id
      id
      serial_id
      reference_number
      company_id
      oil_cost
      freight
      comment
      date_of_purchase
      contact_number
      approved
      total
      submitted
      instance_landing
      instance_labor
      name
      address
      landing_percent
      labor_cost
      principal_person
      date_created
      phone_number
      fax_number
      main_contact
      main_contact_email
      billing_email
      sales_contact
      sales_email
      service_center
      distributor_type
      billing_contact
      status
      discount
      date_purchase
      date_production
      description
      product_id
      order_number
      po_number
    }
  }
`;
export const getArchivedWarranties = /* GraphQL */ `
  query GetArchivedWarranties($input: WarrantyArchiveInput) {
    getArchivedWarranties(input: $input) {
      id
      status
      request_number
      reference_info
      primary_contact
      serial_id
      owner
      date_of_purchase
      freight_cost
      oil_cost
      labor_rate
      service_code_1
      service_code_2
      service_code_3
      comment
      dvo_comment
      date_created
      date_completed
    }
  }
`;
export const getItemWithProduct = /* GraphQL */ `
  query GetItemWithProduct($input: ItemWithProductInput) {
    getItemWithProduct(input: $input) {
      serial
      product_id
      person_id
      date_purchase
      date_production
      image_key
      order_number
      po_number
      description
      first_name
      last_name
      email
    }
  }
`;
export const getItemsWithProduct = /* GraphQL */ `
  query GetItemsWithProduct($input: ItemWithProductInput) {
    getItemsWithProduct(input: $input) {
      serial
      product_id
      person_id
      date_purchase
      date_production
      image_key
      order_number
      po_number
      description
      first_name
      last_name
      email
    }
  }
`;
export const getItemsWithPerson = /* GraphQL */ `
  query GetItemsWithPerson($input: ItemWithPersonInput) {
    getItemsWithPerson(input: $input) {
      serial
      product_id
      person_id
      date_purchase
      date_production
      image_key
      order_number
      po_number
      first_name
      last_name
      email
    }
  }
`;
export const getDailyCount = /* GraphQL */ `
  query GetDailyCount($input: WarrantyInput) {
    getDailyCount(input: $input) {
      daily
    }
  }
`;
export const getItemCount = /* GraphQL */ `
  query GetItemCount($input: TransferInput) {
    getItemCount(input: $input) {
      daily
    }
  }
`;
export const getPartDetail = /* GraphQL */ `
  query GetPartDetail($input: inputForPartDetail) {
    getPartDetail(input: $input) {
      number
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      service_code
      part_number
      product_id
      codes {
        code
        description
      }
      products {
        id
        code
        description
        distributor_cost
        dealer_cost
        manufacture_cost
        msrp
        name
        product_type_id
      }
    }
  }
`;
export const getProductDetail = /* GraphQL */ `
  query GetProductDetail($input: inputForProductDetail) {
    getProductDetail(input: $input) {
      id
      code
      description
      distributor_cost
      dealer_cost
      manufacture_cost
      msrp
      name
      product_type_id
      parts {
        number
        description
        distributor_cost
        dealer_cost
        manufacture_cost
        msrp
        service_code
        part_number
        product_id
      }
    }
  }
`;
